/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Model from 'flarum/common/Model';
export default class Achievement extends Model {
  name() {
    return Model.attribute('name').call(this);
  }
  description() {
    return Model.attribute('description').call(this);
  }
  order() {
    return Model.attribute('order').call(this);
  }
  isVisible() {
    return Model.attribute('isVisible').call(this);
  }
  userCount() {
    return Model.attribute('userCount').call(this);
  }
  category() {
    return Model.hasOne('category').call(this);
  }
  levels() {
    return Model.hasMany('levels').call(this);
  }
  users() {
    return Model.hasMany('users').call(this);
  }
  userAchievements() {
    return Model.hasMany('userAchievements').call(this);
  }
  rule() {
    return Model.attribute('rule').call(this);
  }
}
flarum.reg.add('glowingblue-gamilytics', 'common/models/Achievement', Achievement);